var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreencheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3449_19174)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.09098,
    cy: 3.99999,
    r: 2.66667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99977 1.52588e-05C1.7941 1.52588e-05 -0.000228882 1.79435 -0.000228882 4.00002C-0.000228882 6.20568 1.7941 8.00002 3.99977 8.00002C6.20544 8.00002 7.99977 6.20568 7.99977 4.00002C7.99977 1.79435 6.20544 1.52588e-05 3.99977 1.52588e-05ZM3.96944 5.13968C3.84044 5.26868 3.67077 5.33302 3.50044 5.33302C3.3301 5.33302 3.15877 5.26802 3.02844 5.13802L2.1011 4.23935L2.56544 3.76035L3.49644 4.66268L5.43277 2.76235L5.90077 3.23735L3.96944 5.13968Z",
    fill: "#41A702"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3449_19174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreencheck);
export default __webpack_public_path__ + "static/media/greencheck.ee004a92293d69e027ba38d0468a7b7b.svg";
export { ForwardRef as ReactComponent };